import React from "react";
import Emitter from "./emitter";
import { Helper } from "./helper/helper.service";


class AndroidBack extends React.Component {

    static menuOpen = false;
    static providersVisible = false;
    static isLogin = false;
    static isRegister = false;

    static setMenuOpen(status) {
        AndroidBack.menuOpen = status;
    }

    static setProvidersVisible(status) {
        AndroidBack.providersVisible = status;
    }

    static setIsLogin(status) {
        AndroidBack.isLogin = status;
    }

    static setIsRegister(status) {
        AndroidBack.isRegister = status;
    }

    static handleAndroidBack() {
        if (AndroidBack.menuOpen) {
            Emitter.emit("CLOSE_SIDEBAR");
        } else if (AndroidBack.providersVisible) {
            Emitter.emit("PROVIDERS_VISIBLE_BACK");
        } else if (Helper.isLoginPage(window.location.pathname)) {  //if login page
            Emitter.emit("LOGIN_BACK");
        } else if (Helper.isRegisterPage(window.location.pathname)) {  //if register page
            Emitter.emit("REGISTER_BACK");
        } else {
            Emitter.emit("OPEN_SIDEBAR"); //if @homepage, toggle sidebar
        }
        return true;
    }
}
export default AndroidBack;